import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Layout } from "..";
import { APP_ROUTES, BillingPlans } from "../../data-access";
import { useUser } from "../../hooks";
import { canUseAutoBid } from "../../util/plan-gates";

type PlanGateCheck = "autoBid";

const PLAN_CHECKS: Record<PlanGateCheck, (plan?: BillingPlans | string) => boolean> = {
  autoBid: canUseAutoBid,
};

interface IPrivateRouteProps {
  isForAdminOnly?: boolean;
  /** Block access if user's plan doesn't pass this check; redirects to dashboard */
  requiredPlan?: PlanGateCheck;
  children: JSX.Element;
}

export const PrivateRoute = ({
  isForAdminOnly = false,
  requiredPlan,
  children,
}: IPrivateRouteProps): JSX.Element => {
  const { currentUser, hasAdminRights } = useUser();

  const restrictAccessCondition = isForAdminOnly
    ? !hasAdminRights
    : currentUser === null;

  if (restrictAccessCondition) {
    return <Navigate to={APP_ROUTES.login} />;
  }

  if (requiredPlan && !PLAN_CHECKS[requiredPlan](currentUser?.plan)) {
    return <Navigate to={APP_ROUTES.dashboard} replace />;
  }

  return <Layout>{children}</Layout>;
};

PrivateRoute.propTypes = {
  isForAdminOnly: PropTypes.bool,
  children: PropTypes.element.isRequired,
};
